var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 121,
    viewBox: "0 0 145 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.4731,
    cy: 51.5026,
    rx: 29.2461,
    ry: 29.2461,
    fill: "url(#paint0_linear_308_2197)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.35877,
    cy: 51.5027,
    rx: 3.50953,
    ry: 9.35874,
    transform: "rotate(-90 9.35877 51.5027)",
    fill: "url(#paint1_linear_308_2197)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.5875,
    cy: 51.5027,
    rx: 3.50953,
    ry: 9.35874,
    transform: "rotate(-90 93.5875 51.5027)",
    fill: "url(#paint2_linear_308_2197)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.716923 0.697152 0.697152 0.716923 22.1128 21.3097)",
    fill: "url(#paint3_linear_308_2197)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.716923 0.697152 0.697152 0.716923 80.8329 81.6952)",
    fill: "url(#paint4_linear_308_2197)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.718812 -0.695204 -0.695204 0.718812 80.7509 21.2301)",
    fill: "url(#paint5_linear_308_2197)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.718812 -0.695204 -0.695204 0.718812 22.1947 81.7746)",
    fill: "url(#paint6_linear_308_2197)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.999959 0.00902553 0.00902553 0.999959 51.093 9.38979)",
    fill: "url(#paint7_linear_308_2197)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.50953,
    ry: 9.35874,
    transform: "matrix(-0.999959 0.00902553 0.00902553 0.999959 51.8531 93.6149)",
    fill: "url(#paint8_linear_308_2197)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_2197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.038 105.443C105.906 104.051 100.391 117.212 89.1132 117.212C77.6395 117.212 72.1824 104.194 59.8037 105.061C55.6515 105.352 53.13 107.387 49.4072 107.387C36.0932 107.387 25.3 96.7056 25.3 83.5289C25.3 70.3521 36.0932 59.6702 49.4072 59.6702C62.7212 59.6702 50.7543 59.7542 51.6186 59.7693C69.0451 60.0725 72.4312 35.8115 89.1132 35.8115C111.048 35.8115 115.925 57.547 130.173 74.2191C135.443 80.3857 143 82.6759 143 90.5461C143 99.8474 135.381 107.387 125.983 107.387C123.113 107.387 121.213 105.807 118.038 105.443Z",
    fill: "url(#paint9_linear_308_2197)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_2197",
    x: 19.3,
    y: 30.8115,
    width: 125.7,
    height: 89.3999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_2197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_2197",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_2197",
    x1: 51.4731,
    y1: 22.2566,
    x2: 51.4731,
    y2: 80.7487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_2197",
    x1: 9.35877,
    y1: 42.1439,
    x2: 9.35877,
    y2: 60.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_2197",
    x1: 93.5875,
    y1: 42.1439,
    x2: 93.5875,
    y2: 60.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_2197",
    x1: 3.50953,
    y1: 0,
    x2: 3.50953,
    y2: 18.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7733",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700",
    stopOpacity: 0.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_2197",
    x1: 84.15,
    y1: 35.8115,
    x2: 84.15,
    y2: 117.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.0bb748306ecd7b1262317a6b63979fcd.svg";
export { ForwardRef as ReactComponent };